module.exports = __webpack_public_path__ + "static/media/park_logo.6aeff7c6.png";